import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgClock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.828 44.875a3 3 0 0 1 0 6h-10a3 3 0 1 1 0-6h10ZM26.828 54.875a3 3 0 0 1 0 6h-10a3 3 0 1 1 0-6h10ZM32.828 75.875a3 3 0 0 1 0 6h-10a3 3 0 1 1 0-6h10Z"
        fill="#CAE8DF"
      />
      <path
        d="M47.329 21.007c-8.518-2.282-17.273 2.773-19.555 11.29a15.946 15.946 0 0 0-.512 5.198c.586 8.785 11.751 9.299 19.376 4.896 7.626-4.402 12.763-14.328 5.448-19.229a15.945 15.945 0 0 0-4.757-2.155Z"
        fill="#599F40"
      />
      <path
        d="M52.086 23.162a15.945 15.945 0 0 0-4.758-2.155 16.12 16.12 0 0 0-2.046-.409c-5.815-.773-7.805 6.179-4.836 11.238l5.388 9.185c.445.758 1.423 1.02 2.147.52 6.854-4.724 10.982-13.772 4.105-18.379Z"
        fill="#78B441"
      />
      <path
        d="M46.638 42.391c-3.13 1.808-6.858 2.787-10.205 2.704-8.112-.198-4.72-10.17 2.308-14.228l1.865-1.077c7.028-4.057 17.36-2.01 13.477 5.116-1.603 2.939-4.314 5.678-7.445 7.485Z"
        fill="#007A5F"
      />
      <path
        d="M40.206 29.097c3.901-2.252 8.818-2.743 12.055-1.506a.8.8 0 1 1-.57 1.494c-2.708-1.034-7.12-.66-10.685 1.398l-1.864 1.077c-1.867 1.078-3.47 2.602-4.635 4.24-1.17 1.646-1.86 3.355-1.975 4.785a.8.8 0 0 1-1.596-.129c.145-1.8.985-3.78 2.267-5.583 1.287-1.811 3.058-3.498 5.138-4.7l1.865-1.076ZM30.047 80.88a5.322 5.322 0 1 0 9.218 5.322l7.183-12.441a1.6 1.6 0 0 0-.585-2.186l-6.447-3.722a1.6 1.6 0 0 0-2.186.586L30.047 80.88Z"
        fill="#0F172A"
      />
      <path
        d="M55.125 94.723c17.035 4.564 34.544-5.545 39.109-22.58 4.564-17.034-5.545-34.543-22.58-39.108l-5.14-1.377c-17.035-4.565-34.544 5.544-39.109 22.58-4.564 17.034 5.545 34.543 22.58 39.108l5.14 1.377Z"
        fill="#599F40"
      />
      <path
        d="M78.624 93.896a5.322 5.322 0 0 1-10.644 0c0-.582.377-1.095.926-1.29a32.095 32.095 0 0 0 6.041-2.886c1.535-.942 3.677.094 3.677 1.895v2.281Z"
        fill="#0F172A"
      />
      <path
        d="M89.093 70.766c-4.564 17.035-22.074 27.144-39.109 22.58C32.95 88.78 22.841 71.272 27.405 54.237c4.565-17.035 22.074-27.144 39.109-22.58 17.034 4.565 27.144 22.075 22.579 39.11Z"
        fill="#78B441"
      />
      <path
        d="M93.594 33.404c8.518 2.282 13.572 11.037 11.29 19.554a15.945 15.945 0 0 1-2.155 4.758c-4.9 7.315-14.826 2.178-19.229-5.448-4.402-7.625-3.889-18.79 4.897-19.377a15.944 15.944 0 0 1 5.197.513Z"
        fill="#78B441"
      />
      <path
        d="M102.729 57.716a15.945 15.945 0 0 0 2.155-4.758c1.552-5.79-5.323-8.527-10.712-5.898l-.416.203c-5.545 2.706-7.675 10.093-2.122 12.783 4.04 1.958 8.354 1.762 11.095-2.33Z"
        fill="#599F40"
      />
      <path
        d="M91.03 37.61a2.662 2.662 0 0 1-.638 3.203c-.333.287-.71.525-1.021.836-.311.311-.55.688-.837 1.021a2.662 2.662 0 0 1-4.393-2.932c.347-.692.765-1.357 1.364-1.955.598-.598 1.262-1.017 1.955-1.363a2.661 2.661 0 0 1 3.57 1.19Z"
        fill="#fff"
      />
      <path
        d="M81.931 35.5a.8.8 0 1 1 1.304.927c-1.272 1.788-1.798 4.333-1.606 7.135.192 2.792 1.092 5.757 2.564 8.306 2.64 4.573 7.282 8.12 11.4 8.54A.8.8 0 1 1 95.431 62c-4.788-.49-9.818-4.473-12.623-9.332-1.592-2.757-2.566-5.957-2.774-8.996-.208-3.03.34-5.984 1.897-8.172Z"
        fill="#0F172A"
      />
      <path
        d="M78.812 68.011C75.769 79.368 64.096 86.107 52.74 83.064c-11.357-3.043-18.096-14.716-15.053-26.072 3.043-11.356 14.716-18.096 26.072-15.053 11.356 3.043 18.096 14.716 15.053 26.072Z"
        fill="#E6F4F0"
      />
      <path
        d="M36.914 56.785c3.157-11.783 15.269-18.776 27.052-15.618a.8.8 0 1 1-.414 1.545c-10.93-2.929-22.164 3.557-25.093 14.487a.8.8 0 1 1-1.545-.414Z"
        fill="#0F172A"
      />
      <path
        d="M78.04 67.805a.8.8 0 1 1 1.544.413c-3.157 11.784-15.269 18.776-27.052 15.619a.8.8 0 1 1 .414-1.545c10.93 2.928 22.165-3.558 25.093-14.487Z"
        fill="#fff"
      />
      <path
        d="m52.863 79.512.264-.984a.8.8 0 1 1 1.545.414l-.263.984a.8.8 0 0 1-1.546-.414Zm-9.569-9.3a.8.8 0 0 1 .801 1.385l-.883.51a.8.8 0 1 1-.799-1.386l.882-.51Zm22.958 6.151a.8.8 0 0 1 1.093.293l.51.882a.8.8 0 0 1-1.387.8l-.508-.882a.8.8 0 0 1 .292-1.093ZM42.222 57.38a.8.8 0 0 1-.413 1.546l-.984-.264a.8.8 0 0 1 .414-1.546l.984.264Zm33.452 8.963a.8.8 0 0 1-.415 1.546l-.983-.263a.801.801 0 0 1 .414-1.546l.984.263Zm-26.737-19.97a.8.8 0 0 1 1.092.293l.51.882a.8.8 0 0 1-1.386.8l-.509-.882a.8.8 0 0 1 .293-1.092Zm24.348 6.525a.8.8 0 0 1 .8 1.385l-.882.51a.8.8 0 1 1-.8-1.386l.882-.51ZM61.826 46.06l.264-.984a.8.8 0 0 1 1.546.415l-.264.983a.8.8 0 0 1-1.546-.414Z"
        fill="#80CCB5"
      />
      <path
        d="m57.648 61.655 2.583-9.642a.8.8 0 1 1 1.545.414l-2.583 9.642a.8.8 0 0 0 .08.606l3.432 5.945a.8.8 0 1 1-1.386.8l-3.431-5.944a2.401 2.401 0 0 1-.24-1.821Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgClock)
